import { observable, computed } from 'mobx';
import * as assert from 'assert';
import { AuthorizationStore } from './AuthorizationStore';
import { AbstractStore } from './AbstractStore';
import { ScanStore } from './ScanStore';

export interface ISetupApplicationStore {
    authorizationStore: AuthorizationStore;
    initializeStore(): Promise<void>;
    unInitialize(): void;
}

export class ApplicationStore extends AbstractStore {
    @observable private _isUpdating: boolean = false;

    @observable private _authorizationStore: AuthorizationStore;
    @observable private _scanStore: ScanStore;

    @computed
    public get authorizationStore() {
        return this._authorizationStore;
    }

    @computed
    public get scanStore() {
        assert(this.storeIsReady, 'ApplicationStore# get scanStore called before application store was ready');
        return this._scanStore;
    }

    @computed
    public get isUpdating() {
        return this._isUpdating;
    }

    constructor() {
        super();
        this._authorizationStore = new AuthorizationStore(this);
    }

    protected loadData(): Promise<void> {
        // authorization store is responsible for calling this method when we have a usable auth token.
        assert(this._authorizationStore.isAuthenticated, 'ApplicationStore - initApp called before auth');
        const token: string = this._authorizationStore.authToken;
        assert(null !== token, 'error getting auth token from authorizationStore');

        const initPromises: Promise<void>[] = [];

        this._scanStore = new ScanStore(token);

        initPromises.push(this._scanStore.initializeStore());

        return Promise.all(initPromises)
            .then(() => {
                return;
            })
            .catch(err => {
                // TODO: present initialization error to user
                console.log('ApplicationStore#loadData - initialization error: ', err);
                throw err;
            });
    }

    public update(): Promise<void> {
        if (this._isUpdating === false) {
            this._isUpdating = true;
            return this.initializeStore()
                .then(() => {
                    this._isUpdating = false;
                    return;
                });
        } else {
            return Promise.resolve();
        }
    }

    public unInitialize() {
        this.hasLoadedData = false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data_layer/stores/ApplicationStore.ts